Vue.component('ppcarto-bar-actions',{
  template: `<div class="topbar__area topbar__area--actions">
              <ul class="topbar__btngrp">
                <ppcarto-bar-action-item v-for="action in actions" :action="action"></ppcarto-bar-action-item>
              </ul>
            </div>`,
  data(){
    return {
      actions: [{
        name: 'Anreise planen',
        key: 'rome2rio',
        action: 'rome2rio',
        selected: false
      }]
    }
  },
  created () {
    this.$store.commit('setActions', this.actions);
  }
})
